/* WJW display pricing, independent of Shopify/DPO discount enforcement. */
(function () {
  'use strict';
  function factor(tags) {
    if (!Array.isArray(tags)) return null;
    // Existing non-discountable product families override even stray schedule tags.
    if (tags.includes('Kit') || tags.includes('nomarkdown') ||
        tags.includes('gift-card') || tags.includes('Membership')) return 1;
    var exact = false, max = 0;
    tags.forEach(function (tag) {
      if (typeof tag !== 'string' || !tag.startsWith('discount_')) return;
      exact = true;
      var rest = tag.slice(9);
      if (!rest) return;
      var items = rest.split('_');
      if (items.length % 2) return;
      for (var i = 0; i < items.length; i += 2) {
        var qty = Number(items[i]), pct = Number(items[i + 1]);
        if (Number.isInteger(qty) && qty > 0 && qty <= 999 &&
            Number.isFinite(pct) && pct > 0 && pct <= 100 && pct > max) max = pct;
      }
    });
    if (exact) return (100 - max) / 100;
    if (tags.includes('Kit') || tags.includes('nomarkdown') ||
        tags.includes('gift-card') || tags.includes('Membership')) return 1;
    if (tags.includes('DPOCHN')) return .65;
    return .75; // Historical fallback only for products with no discount_ tag.
  }
  window.WJWDiscountPricing = { factor: factor };
})();
